import { render, staticRenderFns } from "./Secretary.vue?vue&type=template&id=228af984&"
import script from "./Secretary.vue?vue&type=script&lang=ts&"
export * from "./Secretary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports